module.exports = __webpack_public_path__ + "static/media/NoData.6324658a.png";